import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/crmCustomerCar/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/crmCustomerCar',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/crmCustomerCar',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/crmCustomerCar/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/crmCustomerCar',
    method: 'get',
    params: {
      id
    }
  })
}

export function getCustomerCarNo(params) {
  return request({
    url: '/api/crmCustomerCar/getCustomerCarNo',
    method: 'get',
    params
  })
}
